import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { logisticsApi, type LogisticsDashboard } from '../../api/logistics';

const NAV = [
  { to: '/logistics/shipments', label: 'Shipments' },
  { to: '/logistics/carriers', label: 'Carriers' },
  { to: '/logistics/tracking', label: 'Tracking' },
  { to: '/logistics/rates', label: 'Rate comparison' },
  { to: '/logistics/serviceability', label: 'Serviceability' },
  { to: '/logistics/analytics', label: 'Analytics' },
];

export function LogisticsHubPage() {
  const [dashboard, setDashboard] = useState<LogisticsDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void logisticsApi.dashboard().then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  const stats = dashboard
    ? [
        { label: 'Total shipments', value: dashboard.total_shipments },
        { label: 'In transit', value: dashboard.in_transit },
        { label: 'Delivered', value: dashboard.delivered },
        { label: 'Failed', value: dashboard.failed },
        { label: 'Pending pickup', value: dashboard.pending_pickup },
        { label: 'On-time rate', value: `${(dashboard.on_time_rate * 100).toFixed(1)}%` },
      ]
    : [];

  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold">Logistics & Shipping</h1>
      <p className="mt-1 text-sm text-slate-600">Multi-carrier shipping, tracking and delivery management.</p>
      <nav className="mt-4 flex flex-wrap gap-3 text-sm">
        {NAV.map((l) => <Link key={l.to} to={l.to} className="text-slate-700 hover:underline">{l.label}</Link>)}
      </nav>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {stats.map((s) => (
          <div key={s.label} className="rounded-xl border bg-white p-4">
            <p className="text-sm text-slate-500">{s.label}</p>
            <p className="mt-1 text-2xl font-semibold">{String(s.value ?? 0)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
